let currentScrollTop;
const lockBody = () => {
    currentScrollTop = window.pageYOffset;
    document.body.classList.add('locked');
    document.body.style.top = `-${currentScrollTop}px`;
};
const unlockBody = () => {
    document.body.classList.remove('locked');
    document.body.style.top = '';
    requestAnimationFrame(() => {
        document.documentElement.style.setProperty('scroll-behavior', 'auto');
        window.scrollTo({ top: currentScrollTop, behavior: 'auto' });
        document.documentElement.style.removeProperty('scroll-behavior');
    });
};
export { lockBody, unlockBody };
